import { makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) => ({
  fullPage: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  module: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center"
  }
}));
